<template src="./WhatsAppMessage.html"></template>

<script>
import moment from "moment-timezone";
const moment_tz = require("moment-timezone");
import { leerLista } from "../../../../apiService/request/CrudTerapias";
import {
  optionsTemplate,
  parametersTemplate,
  sendNotification,
  urlTemplate,
  getFiles,
} from "../../../../apiService/request/crudMendajes";

export default {
  data() {
    return {
      optionsTemplateitems: ["Template", "Otro mensaje"],
      template: false,
      normalMessage: false,
      typeMessage: "",
      templateOptions: [],
      templateSelected: "",
      normalMessageItems: [],
      messageNormalTemplateSelected: "",
      itemsTemplateSelected: "",
      itemsTemplate: [],
      dataBody: "",
      parametersTemplate: [],
      selectedParameters: [],
      menu: false,
      hourSelected: "",
      menu4: false,
      dataTextBody: "",
      copyDataBody: {},
      dataToMessage: {},
      type: "",
      file: null,
      audio: null,
      title: null,
      image: null,
      video: null,
      name: null,
      urlSelected: "",
      urlItems: [],
      dialog: false,
      viewUrlList: false,
      dataBodyNormalMessage: null,
      translate: {
        imagen: "image",
        video: "video",
        audio: "audio",
        texto: "text",
        ubicacion: "location",
        documento: "document",
      },
      options: {
        locale: "es",
        format: "DD-MM-YYYY",
        clearable: false,
      },
      titlePush: null,
      indexBody: {},
      copySelectedParameters:[],
    };
  },
  props: {
    patientOnline: {
      type: Boolean,
      default: false,
    },
    documentPatient: {
      type: Number,
      default: 0,
    },
    seeNotificationpush: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    if (!this.patientOnline) {
      this.listTempalte();
    }
  },
  computed: {
    enabledBtn() {
      this.copySelectedParameters = [];
      this.copySelectedParameters = this.selectedParameters.filter(e => e !== undefined);
      if (
        this.parametersTemplate.length > 0 &&
        this.parametersTemplate.length === this.copySelectedParameters.length
      ) {
        return true;
      } else if (this.dataBodyNormalMessage !== null) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    asingUrlSelected() {
      if (
        this.templateSelected === "Imagen" ||
        this.messageNormalTemplateSelected === "Imagen"
      ) {
        this.image = this.urlSelected;
      } else if (
        this.templateSelected === "Video" ||
        this.messageNormalTemplateSelected === "Video"
      ) {
        this.video = this.urlSelected;
      } else if (this.messageNormalTemplateSelected === "Audio") {
        this.audio = this.urlSelected;
      } else if (
        this.templateSelected === "Documento" ||
        this.messageNormalTemplateSelected === "Documento"
      ) {
        this.file = this.urlSelected;
        const titleSelected = this.urlItems.find(
          (e) => e.nombre === this.urlSelected
        );
        this.title = titleSelected.valor;
        this.docIdDocument = titleSelected.doc_id;
      }
    },
    async searchListUrl() {
      this.urlItems = [];
      try {
        this.viewUrlList = true;
        const searchList =
          this.templateSelected !== ""
            ? this.templateSelected
            : this.messageNormalTemplateSelected;
        if (
          searchList !== "Documento" &&
          this.messageNormalTemplateSelected !== "Texto" &&
          this.messageNormalTemplateSelected !== "Ubicación"
        ) {
          const response = await urlTemplate(searchList);
          this.urlItems = response.data.data.option;
        } else if (searchList === "Documento") {
          const response = await getFiles(this.documentPatient, 20);
          this.urlItems = response.data.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    sendData() {
      this.$store.dispatch("setCargando", true);
      try {
        if (confirm("¡Está seguro de enviar este mensaje!")) {
          this.dataToMessage = {
            template: this.name === null ? "no_aplica" : this.name,
            params: this.selectedParameters,
            type:
              this.type === ""
                ? this.translate[
                    this.messageNormalTemplateSelected.toLowerCase()
                  ]
                : this.type,
            body: this.dataBody ? this.dataBody : this.dataBodyNormalMessage,
            file: this.file,
            audio: this.audio,
            title: this.title ? this.title : this.titlePush,
            image: this.image,
            video: this.video,
            doc_id: this.docIdDocument,
          };
          this.$emit("dataToSend", this.dataToMessage);
        } else {
          this.$store.dispatch("setCargando", false);
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    chabgeDate(date, i) {
      this.menu = false;
      let myDate = moment(date).format("DD/MM/YYYY");
      this.selectedParameters[i] = myDate;
    },
    changeDataBody(numOrder, i, text) {
      this.selectedParameters = [];
      this.indexBody[numOrder] = text;
      this.dataBody = this.dataTextBody;
      Object.keys(this.indexBody).forEach((e) => {
        const to_replacer = `{{${e}}}`;
        this.dataBody = this.dataBody.replace(to_replacer, this.indexBody[e]);
        if (this.indexBody[e] !== "") {
          this.selectedParameters[e-1] = this.indexBody[e];
        }
      });
    },
    selectHour(i) {
      this.selectedParameters[i] = moment(this.hourSelected, "hh:mm A").format(
        "hh:mm A"
      );
    },
    async searchStructureParameters() {
      this.$store.dispatch("setCargando", true);
      this.parametersTemplate = [];
      this.selectedParameters = [];
      this.dataBody = "";
      let response = null;
      this.indexBody= [];
      try {
        response = await parametersTemplate(this.itemsTemplateSelected);
        this.dataTextBody = response.data.data.data[0].data;
        this.parametersTemplate = response.data.data.data[0].parameters;
        this.type = response.data.data.data[0].type.toLowerCase();
        this.name = response.data.data.data[0].name;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async searchTemplate() {
      this.$store.dispatch("setCargando", true);
      this.dataBody = "";
      this.parametersTemplate = [];
      this.selectedParameters = [];
      this.itemsTemplate = [];
      this.urlSelected = "";
      this.urlItems = [];
      let response = null;
      try {
        if (
          this.templateSelected !== "Texto" &&
          this.templateSelected !== "Ubicación" &&
          this.messageNormalTemplateSelected !== "Texto" &&
          this.messageNormalTemplateSelected !== "Ubicación"
        ) {
          await this.searchListUrl();
        }
        response = await optionsTemplate(this.templateSelected);
        this.itemsTemplate = response.data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async checkType() {
      this.dataBodyNormalMessage = null;
      this.messageNormalTemplateSelected = "";
      this.templateSelected = "";
      this.urlSelected = "";
      this.urlItems = [];
      this.parametersTemplate = [];
      if (this.typeMessage === "Template") {
        this.template = true;
        this.normalMessage = false;
        await this.listTempalte();
      } else if (this.typeMessage === "Otro mensaje") {
        this.normalMessage = true;
        this.template = false;
        await this.listNormalMessage();
      }
    },
    async listTempalte() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await leerLista("opciones_template");
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.templateOptions = respuesta.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async listNormalMessage() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await leerLista("opciones_whatsapp");
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.normalMessageItems = respuesta.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./WhatsAppMessage.scss">
</style>


// WEBPACK FOOTER //
// src/components/Mensajes/MensajesUnificado/WhatsAppMessage/WhatsAppMessage.vue